import isBase64 from './isBase64';

export default function getFontUrl(src) {
  if (isBase64(src)) {
    return src;
  }

  return '\'' + src + '\'';
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/fela/es/getFontUrl.js
// module id = 35
// module chunks = 0